import React from "react";
import Mail from "./Mail";
import NavigatationMenu from "../common/NavigationMenu";
import siteContent from "../../generated/site-content";
import { socialIconMap } from "../../lib/site/iconRegistry";

function FooterContainer() {
  const NAVBARCLASS = {
    ulClass: "flex flex-wrap justify-center gap-x-6 gap-y-3",
    liClass: "",
    aClass:
      "py-1 text-sm font-medium theme-text-muted theme-link-plain",
  };
  const SOCIAL_ITEMS = siteContent.socialLinks.map((item) => {
    const IconComponent = socialIconMap[item.icon];

    return {
      title: item.title,
      link: item.link,
      icon: IconComponent ? <IconComponent /> : null,
    };
  });
  const LEGALBARCLASS = {
    ulClass: "flex flex-wrap justify-center gap-x-4 gap-y-2",
    liClass: "",
    aClass:
      "py-1 text-xs font-medium uppercase tracking-[0.2em] theme-text-muted theme-link-plain",
  };

  return (
    <div className="grid w-full gap-6 border-t theme-border pt-6 text-center md:grid-cols-3 md:items-start">
      <div className="flex flex-col items-center gap-2">
        <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.3em]">
          {siteContent.contact.label}
        </p>
        <Mail
          emailHref={siteContent.contact.emailHref}
          emailLabel={siteContent.contact.emailLabel}
        />
      </div>

      <div className="flex flex-col items-center gap-2">
        <NavigatationMenu
          navBarCss={LEGALBARCLASS}
          navBarItems={siteContent.legalLinks}
        />
      </div>

      <div className="flex flex-col items-center gap-2">
        <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.3em]">
          {siteContent.footer.socialLabel}
        </p>
        <NavigatationMenu navBarCss={NAVBARCLASS} navBarItems={SOCIAL_ITEMS} />
      </div>
    </div>
  );
}
export default FooterContainer;
